import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

export const CommuneShow = () => {
  const [communes, setCommunes] = useState([]);
  const [deleteCommuneId, setDeleteCommuneId] = useState(null);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    async function getInfo() {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/verify`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (data.message === "Please login first") {
          navigate("/adminLogin");
        }
      } catch (error) {
        console.log(error);
      }
    }
    getInfo();
  }, []);

  // Function to fetch all communes
  const getAllCommunes = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/blogs/commune`,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      setCommunes(data);
    } catch (error) {
      console.log(error);
    }
  };

  // Function to delete a commune
  const handleDeleteCommune = async () => {
    try {
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/blogs/commune/delete/${deleteCommuneId}`,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      handleCloseDeleteDialog();
      getAllCommunes();
    } catch (error) {
      console.log(error);
    }
  };

  // Function to open the delete confirmation dialog
  const handleOpenDeleteDialog = (communeId) => {
    setDeleteCommuneId(communeId);
    setDeleteDialogOpen(true);
  };

  // Function to close the delete confirmation dialog
  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setDeleteCommuneId(null);
  };

  useEffect(() => {
    getAllCommunes();
  }, []);

  return (
    <div>
      <div
        style={{ fontSize: "2rem", fontWeight: "500", marginBottom: "1rem" }}
      >
        Our Community:
      </div>

      <TableContainer component={Paper}>
        <Table>
          <TableHead style={{ backgroundColor: "gainsboro" }}>
            <TableRow>
              <TableCell>First Name</TableCell>
              <TableCell>Last Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Contact</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {communes.map((commune) => (
              <TableRow key={commune && commune._id}>
                <TableCell>
                  {commune.settings && commune.settings.fname}
                </TableCell>
                <TableCell>
                  {commune.settings && commune.settings.lname}
                </TableCell>
                <TableCell>
                  {commune.settings && commune.settings.email}
                </TableCell>
                <TableCell>
                  {commune.settings && commune.settings.number}
                </TableCell>
                <TableCell>
                  <Button
                    component={Link}
                    to={`/commune/${commune && commune._id}`}
                    variant="contained"
                    color="primary"
                  >
                    <VisibilityIcon />
                  </Button>

                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => handleOpenDeleteDialog(commune._id)}
                  >
                    <DeleteIcon />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog open={isDeleteDialogOpen} onClose={handleCloseDeleteDialog}>
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this commune?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteCommune} color="primary" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
